import HttpRequest from './HttpRequest';

export const getReviews = async () => {
  try {
    const response = await HttpRequest.get('/reviews');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
